import { render, staticRenderFns } from "./PayVariants.vue?vue&type=template&id=7fe5d63e&scoped=true&"
import script from "./PayVariants.vue?vue&type=script&lang=js&"
export * from "./PayVariants.vue?vue&type=script&lang=js&"
import style0 from "./PayVariants.vue?vue&type=style&index=0&id=7fe5d63e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe5d63e",
  null
  
)

export default component.exports